<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>

    <h2 class="mat-headline text-left">
        {{ 'dialog.confirm-transfer.info'|translate }}
    </h2>

    <ng-container>
        <div class="row">
        <div class="col-1 text-left"><i class="icon-bank text-blue icono"></i> </div>
        <div class="col-11 text-left">
            <span class="mb-3 text-left" [innerHTML]="'dialog.confirm-transfer.complete-transfer'|translate "></span>
            {{data.textParams.iban}}
            <br><br><br>
        </div>
        </div>
        <div class="row">
            <div class="col-1 text-left"><img src="assets/images/blockquote.svg"/></div>
            <div class="col-11 text-left">
                <span class="mb-3 text-left" [innerHTML]="'dialog.confirm-transfer.remember-transfer'|translate "></span>
            <br><br><br>
            </div>
            </div>
    </ng-container>

    <button type="button" class="mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
        <span>{{ 'general.accept'|translate }}</span>
    </button>
</div>
